var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 136,
    viewBox: "0 0 166 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.142 53.4286C167.598 110.399 121.183 136 84.589 136C47.9946 136 0.427734 105.229 0.427734 72.456C0.427734 39.683 9.16276 19.2749 45.9738 6.63746C82.7849 -5.99999 158.686 -3.54176 163.142 53.4286Z",
    fill: "#F7F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3336 34.9206C81.5799 33.1534 84.419 33.1534 86.6654 34.9206L116.174 58.1346C116.939 58.7365 117.404 59.7991 117.404 60.9432C117.404 62.1863 116.855 63.3242 115.984 63.8874L82.9995 85.2024L50.0152 63.8874C49.1437 63.3242 48.5947 62.1863 48.5947 60.9432C48.5947 59.7991 49.0604 58.7365 49.8255 58.1346L79.3336 34.9206Z",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.916 37.46C58.916 35.3255 60.1814 33.5952 61.7423 33.5952H104.256C105.817 33.5952 107.083 35.3255 107.083 37.46V74.4566C107.083 76.5911 105.817 78.3214 104.256 78.3214H61.7423C60.1814 78.3214 58.916 76.5911 58.916 74.4566V37.46Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.7969,
    y: 47.3569,
    width: 34.4048,
    height: 3.44048,
    rx: 1.72024,
    fill: "#E6E5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7969,
    y: 54.2383,
    width: 34.4048,
    height: 3.44048,
    rx: 1.72024,
    fill: "#E6E5FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7969,
    y: 61.1191,
    width: 34.4048,
    height: 3.44048,
    rx: 1.72024,
    fill: "#E6E5FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7969,
    y: 40.4761,
    width: 13.7619,
    height: 3.44048,
    rx: 1.72024,
    fill: "#8E8CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5947 61.301C48.5947 58.6286 51.2899 56.8786 53.6047 58.0479L81.4745 72.1258C82.4372 72.6121 83.5617 72.6121 84.5244 72.1258L112.394 58.0479C114.709 56.8786 117.404 58.6286 117.404 61.301V95.3467C117.404 97.3447 115.844 98.9644 113.919 98.9644H52.0798C50.1551 98.9644 48.5947 97.3447 48.5947 95.3467V61.301Z",
    fill: "url(#paint0_linear_45671_936)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45671_936",
    x1: 158.69,
    y1: 47.3573,
    x2: 100.395,
    y2: 153.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485195,
    stopColor: "#D3D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485295,
    stopColor: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.2a4f50d74ddd5e7f554a0f0a3a26c7b0.svg";
export { ForwardRef as ReactComponent };